// Generated by tools/ftl-types.mjs from src/i18n/locales/en.ftl. Do not edit: run `just i18n-types`.

export const EN_FTL = `### The English catalog: the source every other locale is checked against,
### and the fallback for any message a locale does not have (spec §4.1).
###
### Keep each text value on one line: a line break inside one is part of the
### value. Leading and trailing spaces are trimmed, so a space the English
### needs at either end is written { " " }.
### After an edit, run \`just i18n-types\`.

## Shell

# The browser tab's title.
app-title = English Tutor
# Shown while the first screen loads.
common-starting = Starting…
common-loading = Loading…
# The header's wordmark. <accent> is drawn in the tutor's colour.
logo-wordmark = English <accent>Tutor</accent>
# Bottom navigation tabs: one short word each if it fits.
nav-talk = Talk
nav-progress = Progress
nav-practice = Practice
# Kid register only.
nav-books = Books
nav-lessons = Lessons
nav-account = Account
# Asked when a tab is tapped mid-conversation.
nav-confirm-leave = End your conversation? You will see how it went first.
route-error = That screen could not be loaded.
route-error-home = Go home
# Cycled while a debrief is generated.
loading-analyzing = Analyzing your conversation...
loading-insights = Generating insights...
loading-reviewing = Reviewing your session...

## Refusals: what a learner is told when the server says no

refusal-start-forbidden = Confirm your email address first — the link is in your inbox.
refusal-start-at-capacity = Someone else is talking to the tutor right now. Try again in a minute.
refusal-start-unavailable = The tutor can't be reached just now. Try again in a moment.
# { $wait } is already a phrase: "a minute", "2 minutes", "a few seconds".
refusal-start-rate-limited = That's a lot of conversations just now. Wait { $wait } and try again.
refusal-start-unauthenticated = Sign in again to start a conversation.
refusal-unreachable = Could not reach the tutor. Check your connection and try again.
refusal-start-failed = The conversation could not start. Try again.
# { $wait } is already a phrase: "a minute", "2 minutes", "a few seconds".
refusal-auth-rate-limited = Too many tries. Wait { $wait } and try again.
refusal-auth-failed = That did not work. Try again.
# Fills { $wait } when the server gave no time.
refusal-wait-unknown = a little while
# Fills { $wait } for under 45 seconds.
refusal-wait-seconds = a few seconds
# Fills { $wait } in a refusal, rounded up to whole minutes.
refusal-wait-minutes =
    { $count ->
        [one] a minute
       *[other] { $count } minutes
    }

## Starting and holding a conversation

session-start-kid-title = Ready to talk?
session-start-title = Start a conversation
session-start-kid = Let's talk
session-start = Start talking
session-start-topic = Or start on a topic:
session-start-bubble = What would you like to talk about?
session-start-bubble-kid = What do you want to talk about?
session-start-play = Let's play
session-start-role-play = Or act out a real situation:
# Beside the topic the child picks most often (kid play design §2); no count is shown.
session-start-favourite = Your favourite
# A conversation with no topic, where the topic's name would be.
session-free-chat = Free chat
# A past conversation's row: { $subject } is its topic or "Free chat", { $who } the character's name.
session-row-with = { $subject }, with { $who }
session-today = Today
session-yesterday = Yesterday
session-none = No conversations yet.
session-in-progress = In progress
# Ends the conversation, kid register: a completion, not a hang-up.
session-end-kid = All done
session-end = End
# Shown only while no character is known; { $state } is an internal state name.
session-status = Status: { $state }
session-transcript-hide = Hide what we said
session-transcript-show = Show what we said
# { $reason } is the browser's own explanation.
session-no-mic = No microphone: { $reason }
# { $reason } is one of the session-dropped-* lines, or the server's words.
session-disconnected-reason = Disconnected: { $reason }.
session-dropped-stream = the session stream ended
session-dropped-audio = the audio connection dropped
# After End, when the server could not end the conversation.
session-end-failed = the conversation could not be ended
# { $reason } is the server's explanation of a failed turn.
session-error = Error: { $reason }
session-start-again = Start again
session-reconnect = Reconnect
session-new = Start a new conversation
# The talk button's label, by state.
session-disconnected = Disconnected
session-preparing-mic = Preparing the microphone…
session-tutor-getting-ready = The tutor is getting ready…
session-listening-kid = I'm listening — tap when you're done
session-listening-hold = Listening — release to send
session-listening = Listening…
session-tap-to-talk = Tap to talk
session-hold-to-talk = Hold to talk
# Under the talk button, after an adult's press ended before the microphone opened. A first permission prompt takes the press, so this tells them it worked.
session-mic-allowed = Microphone allowed. Hold the button again to talk.
# The tutor's face, as a button: a tap plays its last line again. A label only, never shown, so a child who cannot read loses nothing.
session-hear-again = Hear that again
session-saying-goodbye = Saying goodbye…
session-hands-free-kid = Talk without holding the button
session-hands-free = Hands-free
# The topics a conversation can start on. The value sent to the tutor stays English; these are only its labels.
topic-food = Food
topic-travel = Travel
topic-work = Work
topic-family = Family
topic-weekend-plans = Weekend plans
topic-presentations = Presentations
topic-animals = Animals
topic-sports = Sports
topic-toys-and-games = Toys and games
topic-school = School
topic-colours = Colours
topic-space = Space
topic-games = Games
topic-cartoons = Cartoons
topic-music = Music
topic-riddles = Riddles
topic-guess-the-animal = Guess the animal
# $name is the tutor character the child teaches (kid play design §7.5).
topic-teach = Teach { $name }
topic-teach-me = Teach me
topic-story-time = Story time
topic-i-spy = I spy
topic-would-you-rather = Would you rather
topic-rhyme-time = Rhyme time
topic-scene-cafe = At a café
topic-scene-doctor = At the doctor's
topic-scene-interview = Job interview
topic-scene-hotel = Hotel check-in
topic-scene-return = Returning something
topic-scene-directions = Asking the way
scene-goal-cafe = Order a drink and something to eat, and say how you'll pay.
scene-goal-doctor = Say what's wrong and since when, and answer the doctor's questions.
scene-goal-interview = Introduce yourself, give one example of your experience, and ask one question.
scene-goal-hotel = Check in with your name and the nights, and ask about one thing in the hotel.
scene-goal-return = Say what you bought, what's wrong with it, and what you want instead.
scene-goal-directions = Ask the way, check one detail, and repeat the directions back.
scene-part-cafe-drink = Order a drink
scene-part-cafe-food = Order something to eat
scene-part-cafe-pay = Say how you'll pay
scene-part-doctor-wrong = Say what's wrong
scene-part-doctor-when = Say when it started
scene-part-doctor-answer = Answer the doctor's question
scene-part-interview-intro = Introduce yourself
scene-part-interview-example = Give an example of your experience
scene-part-interview-ask = Ask the interviewer a question
scene-part-hotel-name = Give your name
scene-part-hotel-nights = Say how many nights
scene-part-hotel-ask = Ask about the hotel
scene-part-return-bought = Say what you bought
scene-part-return-wrong = Say what's wrong with it
scene-part-return-want = Say what you want instead
scene-part-directions-ask = Ask the way
scene-part-directions-detail = Check one detail
scene-part-directions-repeat = Repeat the directions

## The character's face and the transcript

# The avatar's text equivalent, a live region: { $name } is the character, { $state } one of the avatar-* lines.
avatar-says = { $name }: { $state }
avatar-waiting = Waiting
avatar-listening = Listening
avatar-thinking = Thinking
avatar-speaking = Speaking
avatar-concern = Didn't catch that
avatar-celebrate = Pleased
# Screen-reader only, before each of the learner's lines.
transcript-you-said = You said
# A button's accessible name; { $line } is the start of an English line, quoted.
transcript-say-in-english-label = Say "{ $line }" in English
transcript-say-in-english = Say this in English
# A button's accessible name; { $line } is the start of a line, quoted.
transcript-help-label = Get help with "{ $line }"
transcript-warming = The tutor is loading. This takes longer the first time.
transcript-about-to-speak = { $name } is about to speak
transcript-please-wait = Please wait
transcript-warming-visible = Loading the tutor — slower the first time

## Comprehension aids panel

# Above a translation; { $language } is the language's English name.
aids-in-language = In { $language }
aids-hear-it = Hear it
aids-translating = Translating…
aids-translate-into = Translate into { $language }
aids-close = Close
aids-hear-again = Hear it again
aids-hear-correction = Hear the correction
aids-loading-translation = Loading translation…

## The kid register's end of a conversation

celebration-title = Great talking!
celebration-stars = { $stars } out of 5 stars
# <strong> is drawn bold.
celebration-words = You said <strong>{ $words }</strong> words
celebration-turns = over <strong>{ $turns }</strong> turns
celebration-again = Again
# A link under the stars to the page this talk added (kid memory design §3.3).
celebration-new-page = A new page in your scrapbook!

## The scrapbook (kid memory design §3.3)

scrapbook-title = My scrapbook
scrapbook-empty = Your scrapbook is waiting! Have a talk and your first page will be here.
# Before the child's own sentence, which follows in English.
scrapbook-you-said = You said:
scrapbook-hear-it = Hear it
scrapbook-hear-it-failed = That one can't play right now.
scrapbook-previous = Previous page
scrapbook-next = Next page
# Beside the small face of the character the child talked to.
scrapbook-with = Talked with { $name }
# The kid Progress screen's card that opens the scrapbook.
scrapbook-card-open = See your pages
scrapbook-sticker-space = Space sticker
scrapbook-sticker-animals = Animals sticker
scrapbook-sticker-food = Food sticker
scrapbook-sticker-games = Games sticker
scrapbook-sticker-family = Family sticker
scrapbook-sticker-colours = Colours sticker
scrapbook-sticker-school = School sticker
scrapbook-sticker-sports = Sports sticker
scrapbook-sticker-toys = Toys sticker
scrapbook-sticker-book = Book sticker
scrapbook-sticker-music = Music sticker
scrapbook-sticker-weather = Weather sticker
scrapbook-sticker-birthday = Birthday sticker
scrapbook-sticker-nature = Nature sticker
scrapbook-sticker-cartoons = Cartoons sticker
scrapbook-sticker-chat = Chat sticker

## The tutor's volume

volume-title = Tutor volume
volume-intro = How loud your tutor speaks on this device. It takes effect the next time you start a conversation.
volume-silent = Silent
# The slider's spoken value.
volume-value = { $volume } of { $max }
volume-recommended = Recommended ({ $volume })
volume-loudest = Loudest
volume-reset = Reset to recommended

## Signing up and signing in

# Shown when the server refused a sign-in without saying why.
signup-credentials-refused = That email and password do not match an account.
signup-sent-title = Check your email
signup-sent-body = If that address can be used, a link is on its way to it. Open the link to carry on.
signup-sent-spam = Nothing arrived? It can take a minute, and it may be in spam.
signup-sent-back = Back to sign in
signup-create-title = Before we start
signup-sign-in-title = Welcome back
signup-hook = Talk with a tutor who's always ready to listen.
signup-create-intro = Your account keeps your progress, so the tutor remembers what you are working on.
signup-sign-in-intro = Sign in to pick up where you left off.
signup-email = Email
signup-password = Password
# A divider above the profile questions on the sign-up form.
signup-about-you = About you
signup-display-name = What should the tutor call you?
signup-creating = Creating your account…
signup-signing-in = Signing in…
signup-create = Create account
signup-sign-in = Sign in
signup-to-sign-in = I already have an account
signup-to-create = Create an account instead
signup-forgot = Email me a link to set a new password

## The pages a mail link opens: /verify and /reset

link-confirming = Confirming your address…
link-confirmed-title = Address confirmed
link-confirmed-body = You can sign in and start a session.
link-sign-in = Sign in
link-failed-title = That link did not work
link-failed-help = Links last 24 hours and can be used once. Sign up again with the same address and we will send you a new one.
link-back = Back
link-reset-done-title = Password changed
link-reset-done-body = Every device was signed out, including this one. Sign in with the new password.
link-reset-title = Set a new password
link-reset-intro = This signs out every device, including this one.
link-reset-password = New password
common-saving = Saving…
link-reset-save = Save password

## Comprehension aids (Translate, Hear it) and anything else that calls the model on demand

aid-rate-limited = You've used this a lot just now — wait a bit and try again.
aid-not-found = That line is no longer available.
aid-bad-language = The language on your profile isn't one this can translate into.
aid-unauthenticated = Sign in again to use this.
aid-failed = Could not do that right now. Try again in a moment.

## Profile and account

# Account area tabs.
account-title = Account
account-tab-profile = Profile
account-tab-tutor = Tutor
account-tab-history = Grown-ups
account-tab-settings = Settings
profile-display-name = What the tutor calls you
common-saved = Saved.
common-save = Save
profile-email = Email
profile-email-verified = Email verified
common-yes = Yes
common-no = No
profile-level-conflict = Your level was changed somewhere else. Reload the page to see it.
settings-sign-out = Sign out
settings-password-changed = Every other device has been signed out.
settings-unreachable = Could not reach the tutor. Try again.
settings-change-password = Change password
settings-current-password = Current password
settings-new-password = New password
settings-delete-title = Delete this account
settings-delete-body = This removes the account, the learner, every conversation and every recording. It cannot be undone.
settings-delete = Delete account
settings-delete-wrong-password = That password did not match.
settings-delete-password = Your password, to confirm
settings-delete-confirm = Delete everything
common-cancel = Cancel
history-title = Past conversations
history-intro = Written for a grown-up: what your learner is working on, and how each conversation went.

## Choosing a character

# How a character's speaking pace reads, under their name.
character-pace-brisk = Keeps things moving
character-pace-even = Steady
character-pace-slow = Takes their time
character-title = Who would you like to practise with?
character-intro = You can hear each of them first, and change your mind later.
character-save-failed = Couldn't save that choice. Check your connection and try again.
# The preview button's accessible name; { $name } is the character's name.
character-hear-name = Hear { $name }
character-hear = Hear
character-stop = Stop
# Beside a tick on the character already chosen.
character-chosen = chosen
field-password-short = Use a password of at least { $min } characters.
field-email-empty = Enter an email address.
field-email-invalid = That does not look like an email address.
field-name-empty = Enter a name.
field-name-long = That name is too long — keep it under { $max } characters.
field-language-empty = Tell us which language, or choose one from the list.
field-language-long = Keep the language under { $max } characters.
field-language-english = That can't be English — every learner here is learning it.
field-language-unlisted = Choose a language from the list.

## English levels, as the learner describes themselves (adult) and as a parent describes a child (kid)

# An adult's level option: { $code } is the CEFR code ("B1"), { $description } one of the level-* lines below.
level-adult = { $code } — { $description }
level-pre-a1 = I know a handful of words, or none yet
level-a1 = I know a few words and phrases
level-a2 = I can say simple things about myself
level-b1 = I can hold a simple conversation
level-b2 = I can discuss most things comfortably
level-c1 = I can argue a point and be understood
level-c2 = I speak as easily as I do in my own language
# Starters, Movers and Flyers are Cambridge English's young learners' exams; keep the names as the exam board does in your language.
level-kid-pre-a1 = Starters (Pre-A1) — knows a few words, or none yet
level-kid-a1 = Movers (A1) — knows some words and simple phrases
level-kid-a2 = Flyers (A2) — can say simple things about themselves
level-kid-b1 = B1 — can hold a simple conversation
level-kid-b2 = B2 — can discuss most things comfortably
level-kid-c1 = C1 — can argue a point and be understood
level-kid-c2 = C2 — speaks as easily as in their own language
# <muted> is drawn fainter.
field-language-label = Your first language <muted>(optional)</muted>
field-language-hint = The tutor uses this to expect the mistakes speakers of that language usually make.
field-language-none = Prefer not to say
# The last option; choosing it opens a box to type the language in.
field-language-other = Other…
field-language-other-label = Which language?
field-level-label = Your English level
field-level-unknown-hint = Reload the page to change your level.
# Shown in the level select when the stored level is one this app cannot name.
field-level-unknown = Your current level

## Practice: the hub, a pattern and its guide

# Error kinds, as a badge and a filter chip.
kind-grammar = Grammar
kind-lexis = Lexis
kind-discourse = Discourse
kind-prosody = Prosody
# The first filter chip: every kind.
chip-all = All
# Word list chips: how a word got onto the learner's list.
chip-asked = Asked about
chip-corrected = Corrected
practice-empty = Nothing to practise yet — patterns show up here after a conversation or two.
# { $kind } is a kind-* label.
practice-empty-kind = Nothing in { $kind } right now.
words-empty = No words yet — ask to translate or hear a word in a conversation and it will appear here.
words-empty-filtered = No words here right now.

# Pattern names.
pattern-past-simple = Past simple
pattern-present-perfect = Present perfect
pattern-articles = Articles
pattern-subject-verb-agreement = Subject–verb agreement
pattern-prepositions = Prepositions
pattern-countable-uncountable = Countable and uncountable nouns
pattern-comparatives = Comparatives
pattern-conditionals = Conditionals
pattern-phrasal-verbs = Phrasal verbs
pattern-false-friends = False friends
pattern-register = Formal and informal speech
pattern-discourse-markers = Linking words
pattern-filler-density = Filler words
pattern-tense-consistency = Keeping tenses consistent
pattern-pluralization = Plurals
pattern-verb-form = Verb forms
pattern-word-order = Word order
pattern-modal-verbs = Modal verbs
pattern-possessives = Possessives
pattern-other = Other

# What each pattern is about. It sits beside an English example sentence that is never translated.
pattern-past-simple-about = Talking about things that already happened.
pattern-present-perfect-about = Things that started before now and still matter.
# Keep 'a', 'an' and 'the' in English: they are the words being learned.
pattern-articles-about = Choosing a, an or the.
pattern-subject-verb-agreement-about = Making the verb match who is doing it.
# Keep 'in', 'on' and 'at' in English: they are the words being learned.
pattern-prepositions-about = Little words like in, on and at.
pattern-countable-uncountable-about = Things you can count, and things you cannot.
pattern-comparatives-about = Saying how two things are different.
pattern-conditionals-about = Saying what happens if something else happens.
pattern-phrasal-verbs-about = Verbs with a small word after them.
pattern-false-friends-about = Words that look right but mean something else.
pattern-register-about = Speaking in the right way for who you are talking to.
pattern-discourse-markers-about = Words that join your ideas together.
# Keep "um" and "uh" as the English sounds.
pattern-filler-density-about = Saying less "um" and "uh" between words.
pattern-tense-consistency-about = Staying in the same time when you tell a story.
pattern-pluralization-about = Saying more than one of something.
pattern-verb-form-about = Using the right shape of a verb.
pattern-word-order-about = Putting words in the right order.
# Keep 'can', 'must' and 'should' in English: they are the words being learned.
pattern-modal-verbs-about = Words like can, must and should.
pattern-possessives-about = Saying who something belongs to.


practice-title = Practice
practice-words-none = Words you are picking up will appear here.
practice-words-count =
    { $count ->
        [one] { $count } word you have met
       *[other] { $count } words you have met
    }
practice-patterns-none = Patterns you are working on will appear here.
practice-patterns-count =
    { $count ->
        [one] { $count } pattern you are working on
       *[other] { $count } patterns you are working on
    }
# The accessible name of the Patterns / Words switch.
practice-surface-label = What to show
practice-surface-patterns = Patterns
practice-surface-words = Words
# Under a word on the word list.
practice-word-met =
    { $count ->
        [one] met { $count } time
       *[other] met { $count } times
    }
# Under a pattern: how often it has come up.
practice-seen =
    { $count ->
        [one] seen { $count } time
       *[other] seen { $count } times
    }
# Follows practice-seen on a card, after a space; { $date } is a short date.
practice-last = · last { $date }
# Follows practice-seen on a pattern's detail, after a space; { $date } is a short date.
practice-last-practised = · last practised { $date }
practice-start = Practise this
practice-start-conversation = Practise this in a conversation
# English being learned, quoted. Use your language's quotation marks.
common-quoted = “{ $text }”
hub-gone = That pattern is no longer being practised.
hub-close = Close
hub-example = For example
# Above the learner's own mistake.
hub-said = I said
# Above the correction.
hub-should-say = I should say
hub-loading-activity = Loading activity…
# The badges on a pattern's activity: each is followed by a count.
stats-targeted = TARGETED { $count }
stats-recurred = RECURRED { $count }
stats-used-correctly = USED CORRECTLY { $count }
stats-targeted-title = Targeted { $count }x
stats-recurred-title = Recurred { $count }x
stats-used-correctly-title = Used correctly { $count }x

## Progress: the overview and its tabs

progress-title = Progress
progress-tab-overview = Overview
progress-tab-conversations = Conversations
progress-kid-title = How you're doing
progress-kid-empty = Have your first conversation and it will show up here.
# Under a large count of recent conversations, kid register.
progress-kid-recent =
    { $count ->
        [one] recent conversation so far
       *[other] recent conversations so far
    }
# Under a large count of recent conversations.
progress-recent =
    { $count ->
        [one] recent conversation
       *[other] recent conversations
    }
progress-streak = { $days } days in a row
progress-kid-phrases = Words you used well
progress-phrases = Recently got right
progress-empty = Nothing to show yet — finish a conversation and it will appear here.
progress-working-on = Working on
# A link to the practice hub; { $count } more patterns are there.
progress-more = { $count } more in Practice
progress-next-up = Next up
progress-next-practise = Practise: { $pattern }
progress-next-practise-why = { $count ->
    [one] It came up once. A short drill helps it stick.
   *[other] It came up { $count } times. A short drill helps it stick.
}
progress-next-talk = Have a conversation
progress-next-talk-why = Talking is how new patterns turn up to practise.
progress-last-talk = Last conversation: { $when }
progress-window = Last { $weeks } weeks
progress-tile-conversations = Conversations
progress-tile-minutes = Minutes speaking
progress-tile-pace = { $wpm } words a minute
progress-tile-lesson-days = Days with lessons
progress-tile-words = New words
progress-activity-title = Activity
progress-activity-less = Less
progress-activity-more = More
progress-activity-day = { $date }: { $talks ->
    [one] 1 conversation
   *[other] { $talks } conversations
}, { $lessons ->
    [one] 1 lesson
   *[other] { $lessons } lessons
}
progress-patterns-title = Patterns you're working on
progress-pattern-new = Not practised yet
progress-patterns-all = All patterns in Practice
progress-more-charts = More charts
# A pattern's latest outcome, as a badge.
status-used-correctly = Got it
status-targeted = Practised
status-recurred = Came back
activity-empty = No outcomes yet — your first practice will appear here.
activity-title = Activity

## The debrief and its focus areas

debrief-practised = What this session practised
debrief-too-short = That conversation was too short to review. Start another when you are ready.
debrief-failed = The debrief could not be generated.
debrief-title = Debrief
debrief-summary = Summary
debrief-goal = Goal
debrief-goal-reached = Reached
debrief-goal-not-yet = Not yet
debrief-goal-part-done = done
debrief-goal-part-missed = not yet
debrief-strengths = Strengths
debrief-focus-areas = Focus Areas
# How a practised pattern went, once the debrief has run.
debrief-outcome-used-correctly = Got it
debrief-outcome-recurred = Came back
debrief-outcome-targeted = Didn't come up
# How a word the learner chose to practise went.
debrief-word-used = You used it
debrief-word-recurred = Still tricky
debrief-word-targeted = Didn't come up
# How much a cited mistake got in the way.
severity-blocking = Hard to follow
severity-minor = Noticeable
severity-polish = Naturalness
focus-practise = Practice in Hub
# Screen-reader only: the struck pair read as one sentence.
cited-said-better = You said { $said }, better: { $better }
# A button's accessible name; { $line } is the correction, quoted.
cited-hear = Hear "{ $line }"

## Progress charts: the last few weeks

# { $weeks } is the number of weeks the charts cover.
charts-title = Your last { $weeks } weeks
charts-show-table = Show as table
# The first column of every chart's table: the week, by its Monday's date.
charts-week-of = Week of
charts-practising-kid = Your conversations
charts-practising = Practising regularly
charts-practising-summary =
    { $count ->
        [one] { $count } conversation in the last { $weeks } weeks.
       *[other] { $count } conversations in the last { $weeks } weeks.
    }
# A table column and a chart series.
charts-conversations = Conversations
charts-talked-kid = How much you talked
charts-talked = Time spent speaking
charts-talked-summary =
    { $count ->
        [one] { $count } minute of speaking in the last { $weeks } weeks.
       *[other] { $count } minutes of speaking in the last { $weeks } weeks.
    }
charts-minutes = Minutes
charts-pace = Speaking pace
charts-pace-summary-one = { $last } words a minute.
charts-pace-summary = { $last } words a minute most recently, from { $first } in the first week you spoke.
charts-words-a-minute = Words a minute
charts-learned-kid = What you learned
charts-learned = What you've learned
charts-learned-words-kid = Words you asked about
charts-learned-words = New words
charts-learned-patterns-kid = Things you got right
charts-learned-patterns = Patterns you've got
charts-learned-summary-kid =
    { $words ->
        [one] { $words } new word
       *[other] { $words } new words
    }, and { $patterns ->
        [one] { $patterns } thing
       *[other] { $patterns } things
    } you got right, in the last { $weeks } weeks.
charts-learned-summary =
    { $words ->
        [one] { $words } word
       *[other] { $words } words
    } and { $patterns ->
        [one] { $patterns } pattern
       *[other] { $patterns } patterns
    } in the last { $weeks } weeks.
charts-strips-title = Are mistakes going away?
# { $summary } is a list of strips-summary-item, joined by semicolons.
charts-strips-summary = Most recently — { $summary }.
# { $pattern } is a pattern's name, { $mark } one of the mark-*-inline lines.
charts-strips-summary-item = { $pattern }: { $mark }
# Screen-reader only: the header of the pattern-name column.
charts-strips-pattern = Pattern
charts-strips-not-practised = Not practised
# How a pattern went in a week: as a legend and a label, then as it reads mid-sentence.
mark-got = Got it
mark-back = Came back
mark-missed = Didn't come up
mark-got-inline = got it
mark-back-inline = came back
mark-missed-inline = didn't come up

## A word from the word list

# <link> goes to the profile form.
vocab-set-language = <link>Add your language to your profile</link> to see what words mean.
vocab-meaning = What it means
# After the IPA: the accent it is written for.
pronunciation-us = US
vocab-missing = That word isn't in your list.
vocab-back = Back to your words
vocab-back-short = ← Your words
vocab-looking-up = Looking it up…
vocab-met-in = Where you met it
vocab-examples = Try it in a sentence
vocab-writing-examples = Writing a few sentences…

## Say it back, on a practice item's detail

say-back-hold = Hold the button while you speak.
say-back-mic-refused = Allow the microphone to say it back.
say-back-mic-failed = Could not open the microphone.
# The button, at rest.
say-back-button = Say it back
say-back-starting = Opening the microphone…
say-back-recording = Release to stop
say-back-sending = Listening back…
say-back-hint = Hold the button and say it.
say-back-heard-nothing = I didn't catch anything — try again.
# Above the correction the learner is repeating.
say-back-target = I should say
# Above the transcript of the learner's attempt.
say-back-said = You said
say-back-same = Same words as the target.
say-back-caveat = Transcription can mishear — listen to yourself, not just the words.

## Say it with me, on a child's practice card: record yourself and hear it straight back. Written for a child and a parent reading together.

# The microphone button, at rest. The child says the example sentence with the tutor.
say-with-me-button = Say it with me
say-with-me-starting = Opening the microphone…
say-with-me-recording = Tap to stop
# While the child's own recording plays back.
say-with-me-playing = Listen…
# After the child has heard their own recording. Praise for doing it, never for how well.
say-with-me-done = That was you!
say-with-me-too-short = Tap the microphone, then talk.
# The child cannot fix a browser permission; a parent can.
say-with-me-mic = Ask a grown-up to turn on the microphone.

## Storybooks: a shelf and a book read aloud. Written for a child and a parent reading together, or for an adult reading alone.

books-title = Books
books-empty = New books will appear here.
# The title page's button. It opens page 1, and the tap is what lets page 1 play aloud.
books-start = Read
# The accessible name of the sticker on a book the child has read to the end.
books-finished = You read this one
# { $page } and { $count } are numbers, as in "Page 3 of 12".
books-page = Page { $page } of { $count }
books-back = Back
books-next = Next
# The close button's accessible name: it goes back to the shelf.
books-close = Back to the books
books-gone = This book is not here any more.
# After the last page. Praise for reading, never for how well.
books-finished-title = You read it!
books-read-again = Read it again
books-to-shelf = More books
# The reader's toggle for the parent: shows the display-language translation under each English line. Never shown in English.
books-gloss = Translation
# An adult's end of a book: quiet, with no star or celebration. The book's title shows under it.
books-finished-quiet = Finished
# The adult's button on the same screen as books-finished-quiet. It opens the book's title page again.
books-read-again-adult = Read again
# On a book's last page, in both registers. It starts a conversation with the learner's own tutor about the book they just read.
books-talk = Talk about it

## The parent's list of books a child has finished, on the account's history tab

history-books-title = Books read
# An adult's own list, under their conversations.
history-books-none-own = Books you finish will appear here.

## Listen & Write: an adult activity on a storybook passage. Listen, listen with the text, take down three sentences, retell the passage in writing, and read the tutor's suggestions. Nothing is scored; corrections are suggestions, never mistakes.

# The button on an adult's storybook page that opens the activity, and the activity's title. Keep it short.
listen-entry = Listen & Write
# The close button's accessible name: it goes back to the book.
listen-close = Back to the book
# { $step } is a number from 1 to 5; { $name } is the step's name, one of the five below.
listen-step-of = Step { $step } of 5: { $name }
listen-step-listen = Listen
listen-step-transcript = Read along
listen-step-dictation = Take it down
listen-step-write = Write
listen-step-feedback = Feedback
listen-listen-intro = Listen to the passage first, without the text. Just follow the story.
listen-play = Play
listen-stop = Stop
listen-transcript-intro = Listen again with the text. Tap any sentence to hear it again.
# A toggle: when on, sentences are read more slowly.
listen-slower = Slower
listen-dictation-intro = Listen to each sentence and type what you hear.
# { $n } is the sentence's number in this step: 1, 2 or 3.
listen-dictation-sentence = Sentence { $n }
# The play button for one dictated sentence. Each sentence can be played up to three times.
listen-dictation-play = { $left ->
    [one] Play (1 more time)
   *[other] Play ({ $left } more times)
}
listen-dictation-no-plays = Played three times
listen-dictation-input = What you heard
listen-check = Check
listen-try-again = Try again
listen-dictation-target = The sentence
listen-dictation-yours = You wrote
# A legend under the comparison. Missed: in the sentence, not typed. Extra: typed, not in the sentence. Misheard: a different word typed in its place.
listen-dictation-missed = Missed
listen-dictation-extra = Extra
listen-dictation-misheard = Misheard
listen-dictation-same = Every word is there.
# Read by a screen reader before a marked word in the comparison, never shown. Each ends with a colon: the word follows.
listen-dictation-sr-missed = missed:
listen-dictation-sr-extra = extra:
listen-dictation-sr-misheard = misheard:
# Read by a screen reader in place of a word the learner typed differently. Both words are English and are drawn inside <en>.
listen-dictation-sr-instead = you wrote <en>{ $heard }</en> instead of <en>{ $target }</en>
listen-write-intro = Now retell the passage in your own words, without looking at it.
listen-write-label = Your retelling
# A soft guide, never a target: { $min } and { $max } are numbers of words.
listen-write-guide = About { $min }–{ $max } words is a good length.
# Shown while the retelling is too short for feedback. { $min } is a number of words.
listen-write-min = Feedback opens from { $min } words.
# { $max } is a number of characters.
listen-write-too-long = That is longer than the tutor can read at once. Keep it under { $max } characters.
listen-submit = Get feedback
listen-sending = Sending…
listen-waiting = Your tutor is reading what you wrote…
# Shown after half a minute of waiting: the tutor's model is serving a conversation.
listen-busy = Your tutor is busy right now. Your feedback will come — you can wait here or come back to it later from your progress page.
listen-late = This is taking longer than usual. Your feedback will appear on your progress page when it is ready.
listen-failed = The tutor couldn't write feedback this time.
listen-retry = Try again
listen-your-text = What you wrote
# A heading over at most three suggested changes to the learner's text. Never call them mistakes or errors.
listen-suggestions = Suggestions
listen-no-suggestions = No suggestions this time.
# A heading over the learner's text, rewritten to read more naturally.
listen-better = A smoother version
listen-strength = What worked well
# Starts a conversation with the tutor about the book.
listen-talk = Talk about this story
listen-next-passage = Next passage
listen-rate-limited = You've handed in a lot of writing just now. Wait a while and try again.
listen-gone = This passage isn't available any more.
listen-submit-refused = That retelling couldn't be handed in. Check its length and try again.
listen-submit-failed = Couldn't hand in your retelling. Your text is still here — try again in a moment.
listen-retry-failed = Couldn't ask for the feedback again. Try again in a moment.
# A recording elsewhere on the page holds the sound, so the passage did not play.
listen-voice-busy = The sound is in use by a recording. Play this again once it has finished.

## Listen & Write on an adult's progress page: the retellings handed in, newest first. No scores.

history-listen-title = Listen & Write
history-listen-none = Retellings you write will appear here.
# { $first } and { $last } are page numbers of the book.
history-listen-pages = Pages { $first }–{ $last }
history-listen-page = Page { $first }
history-listen-pending = Feedback on its way
history-listen-failed = No feedback yet

## The display language, chosen on the profile and on the sign-in page

# The picker's heading. On a page that is not in English the English words are shown beside it, so nobody is stranded in a language they cannot read.
language-title = Display language
language-intro = Buttons, menus and help appear in this language. Conversations, corrections and your word list stay in English.
language-failed = Couldn't change the language. Check your connection and try again.

## Why the server refused a sign-up, a sign-in, a link or a password

auth-bad-level = Choose a level from the list.
auth-password-refused = That is not your current password.
auth-link-refused = That link is no longer valid.

## Offline: the page a home-screen launch shows when the tutor cannot be reached

# The page's title and its heading.
offline-title = Can't reach the tutor
# One sentence. A parent reads it; a child sees Cappy and the button.
offline-body = The tutor isn't answering. Check that its computer is on, then try again.
# The page's one button.
offline-retry = Try again

## The notice that a newer version of the app has been deployed

update-available = A new version of the tutor is ready.
# Reloads the page onto the new version.
update-reload = Reload
# Hides the notice until the app is next opened.
update-later = Later

## The learner's picture: the profile card's button and the dialog it opens

picture-change = Change picture
picture-remove = Remove picture
picture-dialog-title = Your picture
picture-close = Close
# Marks the picture already chosen in the grid.
picture-current = Current picture
# The dialog's two tabs.
picture-tab-presets = Pictures
picture-tab-photo = Your photo
picture-choose-file = Choose a photo
picture-drop-hint = or drop one here
# The crop view's slider.
picture-zoom = Zoom
# The slider's value as a screen reader speaks it; 100% is the photo just filling the square.
picture-zoom-value = { $percent }%
# Names the crop square for a keyboard: arrow keys move the photo inside it.
picture-crop-label = Move your photo
# What a screen reader calls the crop square, in place of a generic "application".
picture-crop-role = photo framer
picture-use-photo = Use photo
picture-uploading = Uploading…
picture-failed = That photo couldn't be used — try a different one.
picture-rate-limited = That's a lot of photos for one hour. Try again later.
# Choosing a cartoon or removing the picture did not reach the server.
picture-save-failed = Couldn't change your picture. Check your connection and try again.
# The browser could not open the chosen file as an image.
picture-unreadable = That file isn't a photo we can open — try a different one.
# The cartoon pictures' names, read out as each choice's label.
picture-preset-fox = Fox
picture-preset-owl = Owl
picture-preset-cat = Cat
picture-preset-bear = Bear
picture-preset-panda = Panda
picture-preset-rabbit = Rabbit
picture-preset-penguin = Penguin
picture-preset-frog = Frog
picture-preset-whale = Whale
picture-preset-rocket = Rocket
picture-preset-star = Star
picture-preset-robot = Robot

## What Cappy remembers: the parent's card on the profile (kid memory design §5)

memories-title = What Cappy remembers
memories-intro = Small things your child has mentioned, so Cappy can bring them up next time. You can remove any of them.
memories-empty = Cappy hasn't remembered anything yet. When your child mentions something about themselves, it will show up here.
# The remembered words are English and are drawn inside <en>.
memory-likes = Likes: <en>{ $text }</en>
memory-does = Does: <en>{ $text }</en>
memory-has = Has: <en>{ $text }</en>
memory-person = Someone they know: <en>{ $text }</en>
memory-event = Something that happened: <en>{ $text }</en>
memory-forget = Forget
# The remembered text is read out so the button says which one it removes.
memory-forget-label = Forget: { $text }
memory-forget-all = Forget everything
memory-forget-all-confirm = Forget everything Cappy remembers about your child? This can't be undone.
memory-forget-all-yes = Yes, forget everything
memory-forget-all-cancel = Keep them
memory-failed = Something went wrong, so nothing was changed. Please try again.

## Lessons: the recorded course, one set a week. Adult register only.

lessons-title = Lessons
lessons-empty = No lessons have been added yet.
lessons-level = Level { $level }
lessons-level-other = Other
lessons-this-week = This week
lessons-this-week-day = This week · Day { $day }
lessons-start-set = Start this set
lessons-day = Day { $day }
lessons-done = Heard today
lessons-read-today = Read today
lessons-heard-times = { $count ->
    [one] Heard once today
   *[other] Heard { $count } times today
}
lessons-next-set = Next set
lessons-stay = Stay on this set
lessons-back = Back to lessons
lessons-set-gone = This set is not here any more.
lessons-gone = This lesson is not here any more.
lessons-kind-article = Article
lessons-kind-vocabulary = Vocabulary
lessons-kind-mini-story = Mini-story
lessons-kind-pov = Point of view
lessons-kind-audio-article = Audio article
lessons-kind-commentary = Commentary
lessons-kind-other = Lesson
lessons-listen = Listen
lessons-read = Read
lessons-answer = Answer
lessons-open-article = Open the article
lessons-play = Play
lessons-pause = Pause
lessons-back-15 = Back 15 seconds
lessons-speed = Speed { $speed }×
lessons-scrub = Position in the recording
lessons-transcript = Transcript
lessons-article-toggle = Article
lessons-article-frame = The article
lessons-day-of = Day { $day } of { $total }
lessons-continue = Continue: { $step }
lessons-all-done-today = All done for today. Nice listening!
lessons-week-title = Your week
lessons-week-summary = { $count ->
    [one] Listened on 1 of the last 7 days
   *[other] Listened on { $count } of the last 7 days
}
lessons-week-day-done = { $date }: finished a lesson
lessons-week-day-started = { $date }: started listening
lessons-week-day-none = { $date }: no listening
lessons-level-progress = { $finished } of { $total } sets finished
lessons-set-days = Played on { $days } of { $total } days
lessons-set-finished = Finished
lessons-answer-hold = Hold to answer
lessons-answer-release = Release to go on
lessons-answer-start = Play the story
lessons-answer-progress = Question { $n } of { $total }
lessons-answer-none = No answer
lessons-answer-listening = Listening back…
lessons-answer-done = Story finished
lessons-answer-count = You answered { $answered } of { $asked } questions.
lessons-answer-median = Median time to answer: { $seconds } s
lessons-answer-earlier = Other days
lessons-answer-again = Play again
lessons-answer-day-median = { $day }: { $seconds } s
lessons-answer-start-failed = Could not start this play. Try again.
lessons-answer-not-saved = This answer was not saved.

## Milestones (milestones design): moments, never targets.
moments-title = Moments
moments-intro = Things you have done, as they happened.
moments-show-all = Show all { $count }
moments-new = New moment
moments-new-more = { $count ->
    [one] and one more on Progress
   *[other] and { $count } more on Progress
}
moments-nice = Nice!
moment-first-conversation = Your first conversation
moment-conversations = { $count } conversations
moment-long-talk = Five minutes of speaking in one conversation
moment-long-answer = A long answer, all in one go
moment-new-tutor = A new tutor friend
moment-pattern-used = Got it right in a conversation
moment-words = { $count } words met
moment-lesson-set = A lesson set, all seven days
moment-first-book = Your first book

## Dates for a narrow column. English prints \`$name\`, \`Intl\`'s short form;
## the selectors declare \`$day\` and \`$month\` for catalogs whose short form
## is too wide ("Tháng 9", "1 thg 10"), which must read \`$name\` the same way.
date-month-short = { $month ->
   *[other] { $name }
}
date-day-month = { $day ->
   *[other] { $month ->
      *[other] { $name }
   }
}

## For grown-ups: the kid account's page for a parent (kid engagement PRD F2).
## Never a mistake, a level, a streak, or "you missed".

grown-ups-gate = Grown-ups: press and hold
grown-ups-gate-hint = Hold for two seconds to open.
grown-ups-title = For grown-ups
grown-ups-intro = The last seven days, and a few ideas for joining in.
grown-ups-when = When they talked
grown-ups-day-on = { $day }: talked
grown-ups-day-off = { $day }: no talk
grown-ups-what = What they talked about
grown-ups-what-none = Nothing yet this week.
grown-ups-times = { $count ->
    [one] once
   *[other] { $count } times
}
grown-ups-free-talk = Free talk
grown-ups-said = Things they said
grown-ups-said-none = Their own sentences will show up here after a talk.
grown-ups-books = Books finished
grown-ups-books-none = Books they finish this week will show up here.
grown-ups-together = Try it together
grown-ups-try-none = Sit with them for a riddle game; it is the one they talk most in.
# The title and the question are English, drawn inside <en>.
grown-ups-try-book = Ask about <en>{ $title }</en>: <en>“{ $ask }”</en>
grown-ups-try-topic = Ask them about { $topic } at dinner, in English or Vietnamese.
grown-ups-try-riddles = Ask them to tell you a riddle in English, and guess.
grown-ups-try-guess = Think of an animal and give them easy clues in English; let them guess.
grown-ups-try-teach = Ask them to teach you something they know, in English.
grown-ups-try-story = At bedtime, start a story and ask them what happens next.
grown-ups-try-spy = Play I spy at home: name a colour in English and let them find the thing.
grown-ups-try-rather = Ask them a would-you-rather in English, and let them ask you one.
grown-ups-try-rhyme = Say an easy English word and take turns finding words that rhyme.
grown-ups-memories-moved = What Cappy remembers is now on the Grown-ups tab.

## Try this next: one card on the kid start screen (kid engagement PRD F3)

try-next-title = Try this next
`;

/** Each message id, and the variables its English reads: `number` where it selects a plural. */
export type MessageVariables = {
  'app-title': never;
  'common-starting': never;
  'common-loading': never;
  'logo-wordmark': never;
  'nav-talk': never;
  'nav-progress': never;
  'nav-practice': never;
  'nav-books': never;
  'nav-lessons': never;
  'nav-account': never;
  'nav-confirm-leave': never;
  'route-error': never;
  'route-error-home': never;
  'loading-analyzing': never;
  'loading-insights': never;
  'loading-reviewing': never;
  'refusal-start-forbidden': never;
  'refusal-start-at-capacity': never;
  'refusal-start-unavailable': never;
  'refusal-start-rate-limited': {
    wait: 'text';
  };
  'refusal-start-unauthenticated': never;
  'refusal-unreachable': never;
  'refusal-start-failed': never;
  'refusal-auth-rate-limited': {
    wait: 'text';
  };
  'refusal-auth-failed': never;
  'refusal-wait-unknown': never;
  'refusal-wait-seconds': never;
  'refusal-wait-minutes': {
    count: 'number';
  };
  'session-start-kid-title': never;
  'session-start-title': never;
  'session-start-kid': never;
  'session-start': never;
  'session-start-topic': never;
  'session-start-bubble': never;
  'session-start-bubble-kid': never;
  'session-start-play': never;
  'session-start-role-play': never;
  'session-start-favourite': never;
  'session-free-chat': never;
  'session-row-with': {
    subject: 'text';
    who: 'text';
  };
  'session-today': never;
  'session-yesterday': never;
  'session-none': never;
  'session-in-progress': never;
  'session-end-kid': never;
  'session-end': never;
  'session-status': {
    state: 'text';
  };
  'session-transcript-hide': never;
  'session-transcript-show': never;
  'session-no-mic': {
    reason: 'text';
  };
  'session-disconnected-reason': {
    reason: 'text';
  };
  'session-dropped-stream': never;
  'session-dropped-audio': never;
  'session-end-failed': never;
  'session-error': {
    reason: 'text';
  };
  'session-start-again': never;
  'session-reconnect': never;
  'session-new': never;
  'session-disconnected': never;
  'session-preparing-mic': never;
  'session-tutor-getting-ready': never;
  'session-listening-kid': never;
  'session-listening-hold': never;
  'session-listening': never;
  'session-tap-to-talk': never;
  'session-hold-to-talk': never;
  'session-mic-allowed': never;
  'session-hear-again': never;
  'session-saying-goodbye': never;
  'session-hands-free-kid': never;
  'session-hands-free': never;
  'topic-food': never;
  'topic-travel': never;
  'topic-work': never;
  'topic-family': never;
  'topic-weekend-plans': never;
  'topic-presentations': never;
  'topic-animals': never;
  'topic-sports': never;
  'topic-toys-and-games': never;
  'topic-school': never;
  'topic-colours': never;
  'topic-space': never;
  'topic-games': never;
  'topic-cartoons': never;
  'topic-music': never;
  'topic-riddles': never;
  'topic-guess-the-animal': never;
  'topic-teach': {
    name: 'text';
  };
  'topic-teach-me': never;
  'topic-story-time': never;
  'topic-i-spy': never;
  'topic-would-you-rather': never;
  'topic-rhyme-time': never;
  'topic-scene-cafe': never;
  'topic-scene-doctor': never;
  'topic-scene-interview': never;
  'topic-scene-hotel': never;
  'topic-scene-return': never;
  'topic-scene-directions': never;
  'scene-goal-cafe': never;
  'scene-goal-doctor': never;
  'scene-goal-interview': never;
  'scene-goal-hotel': never;
  'scene-goal-return': never;
  'scene-goal-directions': never;
  'scene-part-cafe-drink': never;
  'scene-part-cafe-food': never;
  'scene-part-cafe-pay': never;
  'scene-part-doctor-wrong': never;
  'scene-part-doctor-when': never;
  'scene-part-doctor-answer': never;
  'scene-part-interview-intro': never;
  'scene-part-interview-example': never;
  'scene-part-interview-ask': never;
  'scene-part-hotel-name': never;
  'scene-part-hotel-nights': never;
  'scene-part-hotel-ask': never;
  'scene-part-return-bought': never;
  'scene-part-return-wrong': never;
  'scene-part-return-want': never;
  'scene-part-directions-ask': never;
  'scene-part-directions-detail': never;
  'scene-part-directions-repeat': never;
  'avatar-says': {
    name: 'text';
    state: 'text';
  };
  'avatar-waiting': never;
  'avatar-listening': never;
  'avatar-thinking': never;
  'avatar-speaking': never;
  'avatar-concern': never;
  'avatar-celebrate': never;
  'transcript-you-said': never;
  'transcript-say-in-english-label': {
    line: 'text';
  };
  'transcript-say-in-english': never;
  'transcript-help-label': {
    line: 'text';
  };
  'transcript-warming': never;
  'transcript-about-to-speak': {
    name: 'text';
  };
  'transcript-please-wait': never;
  'transcript-warming-visible': never;
  'aids-in-language': {
    language: 'text';
  };
  'aids-hear-it': never;
  'aids-translating': never;
  'aids-translate-into': {
    language: 'text';
  };
  'aids-close': never;
  'aids-hear-again': never;
  'aids-hear-correction': never;
  'aids-loading-translation': never;
  'celebration-title': never;
  'celebration-stars': {
    stars: 'text';
  };
  'celebration-words': {
    words: 'text';
  };
  'celebration-turns': {
    turns: 'text';
  };
  'celebration-again': never;
  'celebration-new-page': never;
  'scrapbook-title': never;
  'scrapbook-empty': never;
  'scrapbook-you-said': never;
  'scrapbook-hear-it': never;
  'scrapbook-hear-it-failed': never;
  'scrapbook-previous': never;
  'scrapbook-next': never;
  'scrapbook-with': {
    name: 'text';
  };
  'scrapbook-card-open': never;
  'scrapbook-sticker-space': never;
  'scrapbook-sticker-animals': never;
  'scrapbook-sticker-food': never;
  'scrapbook-sticker-games': never;
  'scrapbook-sticker-family': never;
  'scrapbook-sticker-colours': never;
  'scrapbook-sticker-school': never;
  'scrapbook-sticker-sports': never;
  'scrapbook-sticker-toys': never;
  'scrapbook-sticker-book': never;
  'scrapbook-sticker-music': never;
  'scrapbook-sticker-weather': never;
  'scrapbook-sticker-birthday': never;
  'scrapbook-sticker-nature': never;
  'scrapbook-sticker-cartoons': never;
  'scrapbook-sticker-chat': never;
  'volume-title': never;
  'volume-intro': never;
  'volume-silent': never;
  'volume-value': {
    max: 'text';
    volume: 'text';
  };
  'volume-recommended': {
    volume: 'text';
  };
  'volume-loudest': never;
  'volume-reset': never;
  'signup-credentials-refused': never;
  'signup-sent-title': never;
  'signup-sent-body': never;
  'signup-sent-spam': never;
  'signup-sent-back': never;
  'signup-create-title': never;
  'signup-sign-in-title': never;
  'signup-hook': never;
  'signup-create-intro': never;
  'signup-sign-in-intro': never;
  'signup-email': never;
  'signup-password': never;
  'signup-about-you': never;
  'signup-display-name': never;
  'signup-creating': never;
  'signup-signing-in': never;
  'signup-create': never;
  'signup-sign-in': never;
  'signup-to-sign-in': never;
  'signup-to-create': never;
  'signup-forgot': never;
  'link-confirming': never;
  'link-confirmed-title': never;
  'link-confirmed-body': never;
  'link-sign-in': never;
  'link-failed-title': never;
  'link-failed-help': never;
  'link-back': never;
  'link-reset-done-title': never;
  'link-reset-done-body': never;
  'link-reset-title': never;
  'link-reset-intro': never;
  'link-reset-password': never;
  'common-saving': never;
  'link-reset-save': never;
  'aid-rate-limited': never;
  'aid-not-found': never;
  'aid-bad-language': never;
  'aid-unauthenticated': never;
  'aid-failed': never;
  'account-title': never;
  'account-tab-profile': never;
  'account-tab-tutor': never;
  'account-tab-history': never;
  'account-tab-settings': never;
  'profile-display-name': never;
  'common-saved': never;
  'common-save': never;
  'profile-email': never;
  'profile-email-verified': never;
  'common-yes': never;
  'common-no': never;
  'profile-level-conflict': never;
  'settings-sign-out': never;
  'settings-password-changed': never;
  'settings-unreachable': never;
  'settings-change-password': never;
  'settings-current-password': never;
  'settings-new-password': never;
  'settings-delete-title': never;
  'settings-delete-body': never;
  'settings-delete': never;
  'settings-delete-wrong-password': never;
  'settings-delete-password': never;
  'settings-delete-confirm': never;
  'common-cancel': never;
  'history-title': never;
  'history-intro': never;
  'character-pace-brisk': never;
  'character-pace-even': never;
  'character-pace-slow': never;
  'character-title': never;
  'character-intro': never;
  'character-save-failed': never;
  'character-hear-name': {
    name: 'text';
  };
  'character-hear': never;
  'character-stop': never;
  'character-chosen': never;
  'field-password-short': {
    min: 'text';
  };
  'field-email-empty': never;
  'field-email-invalid': never;
  'field-name-empty': never;
  'field-name-long': {
    max: 'text';
  };
  'field-language-empty': never;
  'field-language-long': {
    max: 'text';
  };
  'field-language-english': never;
  'field-language-unlisted': never;
  'level-adult': {
    code: 'text';
    description: 'text';
  };
  'level-pre-a1': never;
  'level-a1': never;
  'level-a2': never;
  'level-b1': never;
  'level-b2': never;
  'level-c1': never;
  'level-c2': never;
  'level-kid-pre-a1': never;
  'level-kid-a1': never;
  'level-kid-a2': never;
  'level-kid-b1': never;
  'level-kid-b2': never;
  'level-kid-c1': never;
  'level-kid-c2': never;
  'field-language-label': never;
  'field-language-hint': never;
  'field-language-none': never;
  'field-language-other': never;
  'field-language-other-label': never;
  'field-level-label': never;
  'field-level-unknown-hint': never;
  'field-level-unknown': never;
  'kind-grammar': never;
  'kind-lexis': never;
  'kind-discourse': never;
  'kind-prosody': never;
  'chip-all': never;
  'chip-asked': never;
  'chip-corrected': never;
  'practice-empty': never;
  'practice-empty-kind': {
    kind: 'text';
  };
  'words-empty': never;
  'words-empty-filtered': never;
  'pattern-past-simple': never;
  'pattern-present-perfect': never;
  'pattern-articles': never;
  'pattern-subject-verb-agreement': never;
  'pattern-prepositions': never;
  'pattern-countable-uncountable': never;
  'pattern-comparatives': never;
  'pattern-conditionals': never;
  'pattern-phrasal-verbs': never;
  'pattern-false-friends': never;
  'pattern-register': never;
  'pattern-discourse-markers': never;
  'pattern-filler-density': never;
  'pattern-tense-consistency': never;
  'pattern-pluralization': never;
  'pattern-verb-form': never;
  'pattern-word-order': never;
  'pattern-modal-verbs': never;
  'pattern-possessives': never;
  'pattern-other': never;
  'pattern-past-simple-about': never;
  'pattern-present-perfect-about': never;
  'pattern-articles-about': never;
  'pattern-subject-verb-agreement-about': never;
  'pattern-prepositions-about': never;
  'pattern-countable-uncountable-about': never;
  'pattern-comparatives-about': never;
  'pattern-conditionals-about': never;
  'pattern-phrasal-verbs-about': never;
  'pattern-false-friends-about': never;
  'pattern-register-about': never;
  'pattern-discourse-markers-about': never;
  'pattern-filler-density-about': never;
  'pattern-tense-consistency-about': never;
  'pattern-pluralization-about': never;
  'pattern-verb-form-about': never;
  'pattern-word-order-about': never;
  'pattern-modal-verbs-about': never;
  'pattern-possessives-about': never;
  'practice-title': never;
  'practice-words-none': never;
  'practice-words-count': {
    count: 'number';
  };
  'practice-patterns-none': never;
  'practice-patterns-count': {
    count: 'number';
  };
  'practice-surface-label': never;
  'practice-surface-patterns': never;
  'practice-surface-words': never;
  'practice-word-met': {
    count: 'number';
  };
  'practice-seen': {
    count: 'number';
  };
  'practice-last': {
    date: 'text';
  };
  'practice-last-practised': {
    date: 'text';
  };
  'practice-start': never;
  'practice-start-conversation': never;
  'common-quoted': {
    text: 'text';
  };
  'hub-gone': never;
  'hub-close': never;
  'hub-example': never;
  'hub-said': never;
  'hub-should-say': never;
  'hub-loading-activity': never;
  'stats-targeted': {
    count: 'text';
  };
  'stats-recurred': {
    count: 'text';
  };
  'stats-used-correctly': {
    count: 'text';
  };
  'stats-targeted-title': {
    count: 'text';
  };
  'stats-recurred-title': {
    count: 'text';
  };
  'stats-used-correctly-title': {
    count: 'text';
  };
  'progress-title': never;
  'progress-tab-overview': never;
  'progress-tab-conversations': never;
  'progress-kid-title': never;
  'progress-kid-empty': never;
  'progress-kid-recent': {
    count: 'number';
  };
  'progress-recent': {
    count: 'number';
  };
  'progress-streak': {
    days: 'text';
  };
  'progress-kid-phrases': never;
  'progress-phrases': never;
  'progress-empty': never;
  'progress-working-on': never;
  'progress-more': {
    count: 'text';
  };
  'progress-next-up': never;
  'progress-next-practise': {
    pattern: 'text';
  };
  'progress-next-practise-why': {
    count: 'number';
  };
  'progress-next-talk': never;
  'progress-next-talk-why': never;
  'progress-last-talk': {
    when: 'text';
  };
  'progress-window': {
    weeks: 'text';
  };
  'progress-tile-conversations': never;
  'progress-tile-minutes': never;
  'progress-tile-pace': {
    wpm: 'text';
  };
  'progress-tile-lesson-days': never;
  'progress-tile-words': never;
  'progress-activity-title': never;
  'progress-activity-less': never;
  'progress-activity-more': never;
  'progress-activity-day': {
    date: 'text';
    lessons: 'number';
    talks: 'number';
  };
  'progress-patterns-title': never;
  'progress-pattern-new': never;
  'progress-patterns-all': never;
  'progress-more-charts': never;
  'status-used-correctly': never;
  'status-targeted': never;
  'status-recurred': never;
  'activity-empty': never;
  'activity-title': never;
  'debrief-practised': never;
  'debrief-too-short': never;
  'debrief-failed': never;
  'debrief-title': never;
  'debrief-summary': never;
  'debrief-goal': never;
  'debrief-goal-reached': never;
  'debrief-goal-not-yet': never;
  'debrief-goal-part-done': never;
  'debrief-goal-part-missed': never;
  'debrief-strengths': never;
  'debrief-focus-areas': never;
  'debrief-outcome-used-correctly': never;
  'debrief-outcome-recurred': never;
  'debrief-outcome-targeted': never;
  'debrief-word-used': never;
  'debrief-word-recurred': never;
  'debrief-word-targeted': never;
  'severity-blocking': never;
  'severity-minor': never;
  'severity-polish': never;
  'focus-practise': never;
  'cited-said-better': {
    better: 'text';
    said: 'text';
  };
  'cited-hear': {
    line: 'text';
  };
  'charts-title': {
    weeks: 'text';
  };
  'charts-show-table': never;
  'charts-week-of': never;
  'charts-practising-kid': never;
  'charts-practising': never;
  'charts-practising-summary': {
    count: 'number';
    weeks: 'text';
  };
  'charts-conversations': never;
  'charts-talked-kid': never;
  'charts-talked': never;
  'charts-talked-summary': {
    count: 'number';
    weeks: 'text';
  };
  'charts-minutes': never;
  'charts-pace': never;
  'charts-pace-summary-one': {
    last: 'text';
  };
  'charts-pace-summary': {
    first: 'text';
    last: 'text';
  };
  'charts-words-a-minute': never;
  'charts-learned-kid': never;
  'charts-learned': never;
  'charts-learned-words-kid': never;
  'charts-learned-words': never;
  'charts-learned-patterns-kid': never;
  'charts-learned-patterns': never;
  'charts-learned-summary-kid': {
    patterns: 'number';
    weeks: 'text';
    words: 'number';
  };
  'charts-learned-summary': {
    patterns: 'number';
    weeks: 'text';
    words: 'number';
  };
  'charts-strips-title': never;
  'charts-strips-summary': {
    summary: 'text';
  };
  'charts-strips-summary-item': {
    mark: 'text';
    pattern: 'text';
  };
  'charts-strips-pattern': never;
  'charts-strips-not-practised': never;
  'mark-got': never;
  'mark-back': never;
  'mark-missed': never;
  'mark-got-inline': never;
  'mark-back-inline': never;
  'mark-missed-inline': never;
  'vocab-set-language': never;
  'vocab-meaning': never;
  'pronunciation-us': never;
  'vocab-missing': never;
  'vocab-back': never;
  'vocab-back-short': never;
  'vocab-looking-up': never;
  'vocab-met-in': never;
  'vocab-examples': never;
  'vocab-writing-examples': never;
  'say-back-hold': never;
  'say-back-mic-refused': never;
  'say-back-mic-failed': never;
  'say-back-button': never;
  'say-back-starting': never;
  'say-back-recording': never;
  'say-back-sending': never;
  'say-back-hint': never;
  'say-back-heard-nothing': never;
  'say-back-target': never;
  'say-back-said': never;
  'say-back-same': never;
  'say-back-caveat': never;
  'say-with-me-button': never;
  'say-with-me-starting': never;
  'say-with-me-recording': never;
  'say-with-me-playing': never;
  'say-with-me-done': never;
  'say-with-me-too-short': never;
  'say-with-me-mic': never;
  'books-title': never;
  'books-empty': never;
  'books-start': never;
  'books-finished': never;
  'books-page': {
    count: 'text';
    page: 'text';
  };
  'books-back': never;
  'books-next': never;
  'books-close': never;
  'books-gone': never;
  'books-finished-title': never;
  'books-read-again': never;
  'books-to-shelf': never;
  'books-gloss': never;
  'books-finished-quiet': never;
  'books-read-again-adult': never;
  'books-talk': never;
  'history-books-title': never;
  'history-books-none-own': never;
  'listen-entry': never;
  'listen-close': never;
  'listen-step-of': {
    name: 'text';
    step: 'text';
  };
  'listen-step-listen': never;
  'listen-step-transcript': never;
  'listen-step-dictation': never;
  'listen-step-write': never;
  'listen-step-feedback': never;
  'listen-listen-intro': never;
  'listen-play': never;
  'listen-stop': never;
  'listen-transcript-intro': never;
  'listen-slower': never;
  'listen-dictation-intro': never;
  'listen-dictation-sentence': {
    n: 'text';
  };
  'listen-dictation-play': {
    left: 'number';
  };
  'listen-dictation-no-plays': never;
  'listen-dictation-input': never;
  'listen-check': never;
  'listen-try-again': never;
  'listen-dictation-target': never;
  'listen-dictation-yours': never;
  'listen-dictation-missed': never;
  'listen-dictation-extra': never;
  'listen-dictation-misheard': never;
  'listen-dictation-same': never;
  'listen-dictation-sr-missed': never;
  'listen-dictation-sr-extra': never;
  'listen-dictation-sr-misheard': never;
  'listen-dictation-sr-instead': {
    heard: 'text';
    target: 'text';
  };
  'listen-write-intro': never;
  'listen-write-label': never;
  'listen-write-guide': {
    max: 'text';
    min: 'text';
  };
  'listen-write-min': {
    min: 'text';
  };
  'listen-write-too-long': {
    max: 'text';
  };
  'listen-submit': never;
  'listen-sending': never;
  'listen-waiting': never;
  'listen-busy': never;
  'listen-late': never;
  'listen-failed': never;
  'listen-retry': never;
  'listen-your-text': never;
  'listen-suggestions': never;
  'listen-no-suggestions': never;
  'listen-better': never;
  'listen-strength': never;
  'listen-talk': never;
  'listen-next-passage': never;
  'listen-rate-limited': never;
  'listen-gone': never;
  'listen-submit-refused': never;
  'listen-submit-failed': never;
  'listen-retry-failed': never;
  'listen-voice-busy': never;
  'history-listen-title': never;
  'history-listen-none': never;
  'history-listen-pages': {
    first: 'text';
    last: 'text';
  };
  'history-listen-page': {
    first: 'text';
  };
  'history-listen-pending': never;
  'history-listen-failed': never;
  'language-title': never;
  'language-intro': never;
  'language-failed': never;
  'auth-bad-level': never;
  'auth-password-refused': never;
  'auth-link-refused': never;
  'offline-title': never;
  'offline-body': never;
  'offline-retry': never;
  'update-available': never;
  'update-reload': never;
  'update-later': never;
  'picture-change': never;
  'picture-remove': never;
  'picture-dialog-title': never;
  'picture-close': never;
  'picture-current': never;
  'picture-tab-presets': never;
  'picture-tab-photo': never;
  'picture-choose-file': never;
  'picture-drop-hint': never;
  'picture-zoom': never;
  'picture-zoom-value': {
    percent: 'text';
  };
  'picture-crop-label': never;
  'picture-crop-role': never;
  'picture-use-photo': never;
  'picture-uploading': never;
  'picture-failed': never;
  'picture-rate-limited': never;
  'picture-save-failed': never;
  'picture-unreadable': never;
  'picture-preset-fox': never;
  'picture-preset-owl': never;
  'picture-preset-cat': never;
  'picture-preset-bear': never;
  'picture-preset-panda': never;
  'picture-preset-rabbit': never;
  'picture-preset-penguin': never;
  'picture-preset-frog': never;
  'picture-preset-whale': never;
  'picture-preset-rocket': never;
  'picture-preset-star': never;
  'picture-preset-robot': never;
  'memories-title': never;
  'memories-intro': never;
  'memories-empty': never;
  'memory-likes': {
    text: 'text';
  };
  'memory-does': {
    text: 'text';
  };
  'memory-has': {
    text: 'text';
  };
  'memory-person': {
    text: 'text';
  };
  'memory-event': {
    text: 'text';
  };
  'memory-forget': never;
  'memory-forget-label': {
    text: 'text';
  };
  'memory-forget-all': never;
  'memory-forget-all-confirm': never;
  'memory-forget-all-yes': never;
  'memory-forget-all-cancel': never;
  'memory-failed': never;
  'lessons-title': never;
  'lessons-empty': never;
  'lessons-level': {
    level: 'text';
  };
  'lessons-level-other': never;
  'lessons-this-week': never;
  'lessons-this-week-day': {
    day: 'text';
  };
  'lessons-start-set': never;
  'lessons-day': {
    day: 'text';
  };
  'lessons-done': never;
  'lessons-read-today': never;
  'lessons-heard-times': {
    count: 'number';
  };
  'lessons-next-set': never;
  'lessons-stay': never;
  'lessons-back': never;
  'lessons-set-gone': never;
  'lessons-gone': never;
  'lessons-kind-article': never;
  'lessons-kind-vocabulary': never;
  'lessons-kind-mini-story': never;
  'lessons-kind-pov': never;
  'lessons-kind-audio-article': never;
  'lessons-kind-commentary': never;
  'lessons-kind-other': never;
  'lessons-listen': never;
  'lessons-read': never;
  'lessons-answer': never;
  'lessons-open-article': never;
  'lessons-play': never;
  'lessons-pause': never;
  'lessons-back-15': never;
  'lessons-speed': {
    speed: 'text';
  };
  'lessons-scrub': never;
  'lessons-transcript': never;
  'lessons-article-toggle': never;
  'lessons-article-frame': never;
  'lessons-day-of': {
    day: 'text';
    total: 'text';
  };
  'lessons-continue': {
    step: 'text';
  };
  'lessons-all-done-today': never;
  'lessons-week-title': never;
  'lessons-week-summary': {
    count: 'number';
  };
  'lessons-week-day-done': {
    date: 'text';
  };
  'lessons-week-day-started': {
    date: 'text';
  };
  'lessons-week-day-none': {
    date: 'text';
  };
  'lessons-level-progress': {
    finished: 'text';
    total: 'text';
  };
  'lessons-set-days': {
    days: 'text';
    total: 'text';
  };
  'lessons-set-finished': never;
  'lessons-answer-hold': never;
  'lessons-answer-release': never;
  'lessons-answer-start': never;
  'lessons-answer-progress': {
    n: 'text';
    total: 'text';
  };
  'lessons-answer-none': never;
  'lessons-answer-listening': never;
  'lessons-answer-done': never;
  'lessons-answer-count': {
    answered: 'text';
    asked: 'text';
  };
  'lessons-answer-median': {
    seconds: 'text';
  };
  'lessons-answer-earlier': never;
  'lessons-answer-again': never;
  'lessons-answer-day-median': {
    day: 'text';
    seconds: 'text';
  };
  'lessons-answer-start-failed': never;
  'lessons-answer-not-saved': never;
  'moments-title': never;
  'moments-intro': never;
  'moments-show-all': {
    count: 'text';
  };
  'moments-new': never;
  'moments-new-more': {
    count: 'number';
  };
  'moments-nice': never;
  'moment-first-conversation': never;
  'moment-conversations': {
    count: 'text';
  };
  'moment-long-talk': never;
  'moment-long-answer': never;
  'moment-new-tutor': never;
  'moment-pattern-used': never;
  'moment-words': {
    count: 'text';
  };
  'moment-lesson-set': never;
  'moment-first-book': never;
  'date-month-short': {
    month: 'number';
    name: 'text';
  };
  'date-day-month': {
    day: 'number';
    month: 'number';
    name: 'text';
  };
  'grown-ups-gate': never;
  'grown-ups-gate-hint': never;
  'grown-ups-title': never;
  'grown-ups-intro': never;
  'grown-ups-when': never;
  'grown-ups-day-on': {
    day: 'text';
  };
  'grown-ups-day-off': {
    day: 'text';
  };
  'grown-ups-what': never;
  'grown-ups-what-none': never;
  'grown-ups-times': {
    count: 'number';
  };
  'grown-ups-free-talk': never;
  'grown-ups-said': never;
  'grown-ups-said-none': never;
  'grown-ups-books': never;
  'grown-ups-books-none': never;
  'grown-ups-together': never;
  'grown-ups-try-none': never;
  'grown-ups-try-book': {
    ask: 'text';
    title: 'text';
  };
  'grown-ups-try-topic': {
    topic: 'text';
  };
  'grown-ups-try-riddles': never;
  'grown-ups-try-guess': never;
  'grown-ups-try-teach': never;
  'grown-ups-try-story': never;
  'grown-ups-try-spy': never;
  'grown-ups-try-rather': never;
  'grown-ups-try-rhyme': never;
  'grown-ups-memories-moved': never;
  'try-next-title': never;
};
